import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: ${({ theme }) => theme.spacing.lg};
`;

export const Sheet = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 2rem;
  width: 100%;
  max-width: 48rem;
  max-height: 85vh;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing.xl};
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const StepTitle = styled.span`
  font-size: 1.7rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const CloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1;
  padding: 0.4rem;
`;

export const BackBtn = styled.button<{ $accent: string }>`
  background: none;
  border: none;
  font-size: 1.3rem;
  cursor: pointer;
  color: ${({ $accent }) => $accent};
  font-weight: 600;
  padding: 0;
`;

export const ServiceGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const ServiceChip = styled.button<{
  $selected: boolean;
  $accent: string;
}>`
  background-color: ${({ $selected, $accent, theme }) =>
    $selected ? $accent : theme.colors.surface};
  border-radius: 2rem;
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.md}`};
  font-size: 1.4rem;
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.white : theme.colors.darkSlate};
  font-weight: 500;
  cursor: pointer;
  border: none;
`;

export const ChipSubtext = styled.span`
  display: block;
  font-size: 1.1rem;
  margin-top: 0.2rem;
  opacity: 0.75;
`;

export const ChipNote = styled.span`
  display: block;
  font-size: 1rem;
  margin-top: 0.1rem;
  opacity: 0.6;
`;

export const SectionLabel = styled.span`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  margin-top: ${({ theme }) => theme.spacing.lg};
  display: block;
`;

export const DateList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs};
  max-height: 18rem;
  overflow-y: auto;
`;

export const DateBtn = styled.button<{ $selected: boolean; $accent: string }>`
  background-color: ${({ $selected, $accent, theme }) =>
    $selected ? $accent : theme.colors.surface};
  border: none;
  border-radius: 1rem;
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.md}`};
  font-size: 1.4rem;
  font-weight: 600;
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.white : theme.colors.darkSlate};
  cursor: pointer;
  text-align: left;
`;

export const SlotGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const SlotBtn = styled.button<{ $selected: boolean; $accent: string }>`
  background-color: ${({ $selected, $accent, theme }) =>
    $selected ? $accent : theme.colors.surface};
  border: none;
  border-radius: 1rem;
  padding: ${({ theme }) => `${theme.spacing.sm} ${theme.spacing.md}`};
  font-size: 1.3rem;
  font-weight: 500;
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.white : theme.colors.darkSlate};
  cursor: pointer;
`;

export const PrimaryBtn = styled.button<{ $accent: string }>`
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.xl};
  background-color: ${({ $accent }) => $accent};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 1.2rem;
  padding: ${({ theme }) => theme.spacing.md};
  font-size: 1.5rem;
  font-weight: 700;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const SubmitError = styled.div`
  color: ${({ theme }) => theme.colors.error};
  font-size: 1.3rem;
  margin-bottom: 0.8rem;
`;

export const DoneWrap = styled.div`
  padding: 3.2rem 0;
  text-align: center;
`;

export const ConfirmIcon = styled.div<{ $accent: string }>`
  font-size: 4.4rem;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  color: ${({ $accent }) => $accent};
`;

export const ConfirmTitle = styled.div`
  font-size: 1.9rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const ConfirmText = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-align: center;
  line-height: 2rem;
`;

export const ServicePriceBox = styled.div<{ $accent: string }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ $accent }) => `${$accent}1A`};
  border: 0.1rem solid ${({ $accent }) => `${$accent}33`};
  border-radius: 1rem;
  padding: 1rem 1.4rem;
  margin-bottom: 1.2rem;
`;

export const ServicePriceLabel = styled.span<{ $accent: string }>`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ $accent }) => $accent};
`;

export const ServicePriceValue = styled.span<{ $accent: string }>`
  font-size: 1.6rem;
  font-weight: 700;
  color: ${({ $accent }) => $accent};
  margin-top: 0.2rem;
`;

export const ServicePriceNote = styled.span`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slate};
  margin-top: 0.2rem;
`;

export const CodeBox = styled.div<{ $accent: string }>`
  margin: 2rem 0;
  padding: 1.6rem 2rem;
  border-radius: 1.2rem;
  background-color: ${({ $accent }) => `${$accent}1A`};
  border: 0.1rem solid ${({ $accent }) => `${$accent}33`};
`;

export const CodeLabel = styled.div<{ $accent: string }>`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${({ $accent }) => $accent};
  text-transform: uppercase;
  letter-spacing: 0.1rem;
`;

export const CodeValue = styled.div<{ $accent: string }>`
  font-size: 3.8rem;
  font-weight: 800;
  letter-spacing: 0.8rem;
  color: ${({ $accent }) => $accent};
  margin: 0.6rem 0;
`;

export const CodeHint = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slate};
  line-height: 1.4;
`;

export const RepeatRow = styled.div<{ $accent: string; $selected: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.2rem 1.4rem;
  border: 0.1rem solid
    ${({ $accent, $selected, theme }) =>
      $selected ? $accent : theme.colors.border};
  background-color: ${({ $accent, $selected }) =>
    $selected ? `${$accent}1A` : 'transparent'};
  border-radius: 1.2rem;
  cursor: pointer;
  margin-top: ${({ theme }) => theme.spacing.sm};

  input[type='checkbox'] {
    margin-top: 0.3rem;
    width: 1.8rem;
    height: 1.8rem;
    accent-color: ${({ $accent }) => $accent};
    flex-shrink: 0;
    cursor: pointer;
  }
`;

export const RepeatCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const RepeatTitle = styled.span`
  font-size: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const RepeatSub = styled.span`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.4;
`;
